export default __webpack_public_path__ + "static/media/oval-copy.66672886.svg";